// PDFPreview.js  (updated)
import React from "react";
import { createPortal } from "react-dom";

const PDFPreview = ({ url, filename = "PDF Preview", onClose }) => {
  if (!url) return null;

  // Force-download helper (cross-origin safe)
  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(url); // token is in the URL, no credentials needed
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      // ensure .pdf extension
      const safeName = filename?.toLowerCase().endsWith(".pdf")
        ? filename
        : `${filename || "document"}.pdf`;
      a.download = safeName;

      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const overlay = (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      role="dialog"
      aria-label="PDF preview"
    >
      <div className="flex flex-col bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-5xl h-[90vh] max-h-[90vh]">
        {/* ---------- Header ---------- */}
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-medium truncate">{filename}</h3>

          <div className="flex items-center space-x-2">
            {/* Download */}
            <button
              onClick={handleDownload}
              className="flex items-center px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Download
            </button>

            {/* Close */}
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* ---------- PDF Viewer ---------- */}
        <iframe
          src={`${url}#toolbar=0&zoom=page-fit`}
          title={filename}
          className="flex-1 w-full h-full"
        />
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
};

export default PDFPreview;
